function initButtonCharacterStagger() {
  const offsetIncrement = 0.01;
  const buttons = document.querySelectorAll('[data-button-animate-chars]');

  buttons.forEach(button => {
    const text = button.textContent;
    button.innerHTML = '';

    const words = text.split(' ');
    
    words.forEach((word, index) => {
      const span = document.createElement('span');
      span.textContent = word;
      span.style.transitionDelay = `${index * offsetIncrement}s`;

      button.appendChild(span);
      
      // Add space between words (except after the last word)
      if (index < words.length - 1) {
        button.appendChild(document.createTextNode(' '));
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initButtonCharacterStagger();
});